import Vue from 'vue'
import Router from 'vue-router'
import Introduction from '@/components/intro/Introduction.vue';
import Authentication from '@/components/intro/Authentication.vue';
import Users from '@/components/api_methods/Users.vue';
import Brands from '@/components/api_methods/Brands.vue';
import Campaigns from '@/components/api_methods/Campaigns.vue';
import Links from '@/components/api_methods/Links.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'getting-started',
      component: Introduction,
        meta: {
            'title': 'Getting Started'
        },
    },
      {
          path: '/authentication',
          name: 'authentication',
          component: Authentication,
          meta: {
              'title': 'Authentication'
          },
      },
      {
          path: '/users',
          name: 'users',
          component: Users,
          meta: {
              'title': 'Users | API Method'
          },
      },
      {
          path: '/brands',
          name: 'brands',
          component: Brands,
          meta: {
              'title': 'Brands | API Method'
          },
      },
      {
          path: '/campaigns',
          name: 'campaigns',
          component: Campaigns,
          meta: {
              'title': 'Campaigns | API Method'
          },
      },
      {
          path: '/links',
          name: 'links',
          component: Links,
          meta: {
              'title': 'Links | API Method'
          },
      }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js